<template>
<div class="div">
	<link rel="prefetch" href="http://www.fitportal.com.cn/wordpress"/>
<svg width="500" height="500">
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-3" d="M261.91,46.55c-.6-.64-1.22-1.29-1.85-1.92s-1.28-1.26-1.89-1.82A151.34,151.34,0,0,0,152.35,0h-1.24A152.28,152.28,0,0,0,42.73,258.08h0l.45.47.58.6.11.11.76.79A11.37,11.37,0,0,0,47.18,262a11.64,11.64,0,0,0,17.11-12.32l-.14-.75h0c-.13-.69-.25-1.37-.37-2a63.94,63.94,0,0,1,14.44-52.26c1-1.16,2-2.26,3.09-3.37a63.74,63.74,0,0,1,65.66-16l.37.14a59.84,59.84,0,0,1,7.23,2.9l.23.15.25.15c2,1.23,4.08,2.37,6.13,3.38A85.73,85.73,0,0,0,261.91,46.55ZM77.79,187.82c-1.16,1.18-2.24,2.36-3.32,3.61a68.89,68.89,0,0,0-15.56,56.25c.16.91.32,1.81.5,2.72v.79l.09.09a6.7,6.7,0,0,1-9.95,6.38,6.47,6.47,0,0,1-1.45-1.1l-.72-.75-.65-.67-.45-.47h0q-1.07-1.16-2.07-2.36c-.53-.63-1-1.28-1.54-1.93l-.38-.47A64.18,64.18,0,0,1,46,168.08q1-1.11,2.08-2.19l.05-.06a64.26,64.26,0,0,1,87.44-3s2.25,2,3.27,3,2,2,3,2.88A68.59,68.59,0,0,0,77.79,187.82Zm202.43-81.41a80.79,80.79,0,0,1-116.83,71.15q-3-1.5-6-3.31h0a80.56,80.56,0,0,1-15.06-11.86c-1.12-1.12-3.37-3.14-3.49-3.25a69.22,69.22,0,0,0-94.21,3.25h0A69.19,69.19,0,0,0,26.94,229.8,147.4,147.4,0,0,1,151.15,5h1.2A146.46,146.46,0,0,1,254.78,46.4c.6.56,1.2,1.13,1.79,1.72s1.17,1.19,1.72,1.79h0A80.3,80.3,0,0,1,280.22,106.41Z"/>
      <path class="cls-1a" d="M139.83,205v4.65h-30.9v20.71h27.45V235H108.93v27.29h-5.46V205Z"/>
      <path class="cls-1b" d="M152.43,205v57.3H147V205Z"/>
      <path class="cls-1c" d="M203.63,205v4.65h-20v52.65h-5.41V209.67h-19.9V205Z"/>
      <path class="cls-1d" d="M234.45,205a21.24,21.24,0,0,1,7,1.08,14.72,14.72,0,0,1,5.38,3.21,14.22,14.22,0,0,1,3.39,5.18,20.39,20.39,0,0,1,0,13.8,14.19,14.19,0,0,1-3.45,5.18,14.71,14.71,0,0,1-5.38,3.21,21.26,21.26,0,0,1-7,1.08h-20v24.56h-5.46V205Zm-1.23,28.07a14.11,14.11,0,0,0,9.23-2.89q3.53-2.89,3.53-8.83t-3.53-8.83a14.11,14.11,0,0,0-9.23-2.89H214.46v23.44Z"/>
      <path class="cls-1e" d="M258.22,222.35a28.28,28.28,0,0,1,5.06-9.51,24.36,24.36,0,0,1,8.47-6.58,29.75,29.75,0,0,1,23.63,0,24.47,24.47,0,0,1,8.43,6.58,28.28,28.28,0,0,1,5.06,9.51,38.84,38.84,0,0,1,0,22.63,27.82,27.82,0,0,1-5.06,9.47,24.67,24.67,0,0,1-8.43,6.54,29.75,29.75,0,0,1-23.63,0,24.57,24.57,0,0,1-8.47-6.54,27.82,27.82,0,0,1-5.06-9.47A38.84,38.84,0,0,1,258.22,222.35Zm5,20.5a24.66,24.66,0,0,0,3.85,8.11,19.38,19.38,0,0,0,6.7,5.74,20.67,20.67,0,0,0,9.79,2.17,20.43,20.43,0,0,0,9.75-2.17A19.52,19.52,0,0,0,300,251a24.71,24.71,0,0,0,3.85-8.11,34.7,34.7,0,0,0,0-18.42,24.77,24.77,0,0,0-3.85-8.07,19.53,19.53,0,0,0-6.66-5.74,20.43,20.43,0,0,0-9.75-2.17,20.67,20.67,0,0,0-9.79,2.17,19.4,19.4,0,0,0-6.7,5.74,24.73,24.73,0,0,0-3.85,8.07A34.7,34.7,0,0,0,263.22,242.85Z"/>
      <path class="cls-1f" d="M345.28,205a24.9,24.9,0,0,1,6.7.88,16.22,16.22,0,0,1,5.54,2.69,13,13,0,0,1,3.77,4.66,15,15,0,0,1,1.41,6.7,16.09,16.09,0,0,1-2.81,9.47,12.81,12.81,0,0,1-8.35,5.14v.16a12.74,12.74,0,0,1,4.66,1.49,9.37,9.37,0,0,1,3,2.77,11.43,11.43,0,0,1,1.69,3.89,28.58,28.58,0,0,1,.68,4.77q.08,1.45.16,3.53t.32,4.21a25.89,25.89,0,0,0,.76,4,7.65,7.65,0,0,0,1.4,2.93h-6a7,7,0,0,1-.76-2,17.22,17.22,0,0,1-.4-2.41q-.12-1.24-.2-2.45t-.16-2.09q-.16-3-.52-6.06a16.62,16.62,0,0,0-1.52-5.38,9.49,9.49,0,0,0-3.37-3.81,10.18,10.18,0,0,0-6.06-1.28H324.49v25.44H319V205Zm-.4,27.21a14.61,14.61,0,0,0,4.74-.76,11.78,11.78,0,0,0,3.93-2.21,10.82,10.82,0,0,0,2.69-3.49,10.54,10.54,0,0,0,1-4.69,11.28,11.28,0,0,0-3-8.35q-3-3-9.31-3H324.49v22.55Z"/>
      <path class="cls-1g" d="M412.29,205v4.65h-20v52.65h-5.46V209.67h-19.9V205Z"/>
      <path class="cls-1h" d="M435.08,205l22.47,57.3h-5.86l-7-17.82H418.63l-6.9,17.82H406L429,205Zm7.78,34.83-11.07-29.37-11.48,29.37Z"/>
      <path class="cls-1j" d="M468.22,205v52.65h32.1v4.65H462.77V205Z"/>
      </g></g>
</svg>

</div>
</template>

<script>
export default {
  data() {},
  created() {
    setTimeout(() => {
      window.location.href = "http://www.fitportal.com.cn/wordpress";
    }, 5000);
  },
  methods: {},
  computed: {}
};
</script>

<style>
.cls-1a {
  animation: moveA 6s linear forwards;
}
@keyframes moveA {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1b {
  animation: moveB 6s linear forwards;
}
@keyframes moveB {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  5% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1c {
  animation: moveC 6s linear forwards;
}
@keyframes moveC {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  10% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1d {
  animation: moveD 6s linear forwards;
}
@keyframes moveD {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  15% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1e {
  animation: moveE 6s linear forwards;
}
@keyframes moveE {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  20% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1f {
  animation: moveF 6s linear forwards;
}
@keyframes moveF {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  25% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1g {
  animation: moveG 6s linear forwards;
}
@keyframes moveG {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  30% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1h {
  animation: moveH 6s linear forwards;
}
@keyframes moveH {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  35% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
.cls-1j {
  animation: moveJ 6s linear forwards;
}
@keyframes moveJ {
  0% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  40% {
    stroke-dasharray: 0, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
}
/* .cls-1a {
  animation: moveA 6s linear forwards;
}
@keyframes moveA {
  0% {
    stroke-dasharray: 100px, 100px;
    stroke: #fff;
    stroke-opacity: 0;
    stroke-width: 1px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: rgb(255, 255, 255);
    stroke-opacity: 1;
    stroke-width: 1px;
    fill: #fff;
  }
} */
.cls-2 {
  fill: #feae00;
  animation: move2 4s linear forwards;
}
@keyframes move2 {
  0% {
    stroke-dasharray: 5px, 100px;
    stroke: #feae00;
    stroke-opacity: 0;
    stroke-width: 3px;
    fill: #000;
  }
  100% {
    stroke-dasharray: 100px, 0px;
    stroke: #fff;
    stroke-opacity: 0.5;
    stroke-width: 2px;
    fill: #feae00;
  }
}
.cls-3 {
  fill: #feae00;
  animation: move3 6s linear forwards;
}
@keyframes move3 {
  0% {
    stroke-dasharray: 70px, 10px;
    stroke: #0081C9;
    stroke-opacity: 0;
    stroke-width: 2px;
    fill: #000;
  }
  30% {
    stroke-opacity: 0.3;
  }
  70% {
    fill: #fff;
  }
  100% {
    stroke-dasharray: 128px, 0px;
    stroke: #feae00;
    stroke-opacity: 0;
    stroke-width: 3px;
    fill: #fff;
  }
}
body {
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.div {
  width: 100%;
  height: 10%;
  color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue